// Code generated by @hex-insights/frontend-generator; DO NOT EDIT.

export type GraphTypeNames = {
	Announcement: "Announcement";
	AnnouncementConnection: "AnnouncementConnection";
	AnnouncementEdge: "AnnouncementEdge";
	CalendarEvent: "CalendarEvent";
	CalendarEventConnection: "CalendarEventConnection";
	CalendarEventEdge: "CalendarEventEdge";
	CalendarEventResponse: "CalendarEventResponse";
	CalendarEventResponseConnection: "CalendarEventResponseConnection";
	CalendarEventResponseEdge: "CalendarEventResponseEdge";
	MediaAttachment: "MediaAttachment";
	MediaAttachmentConnection: "MediaAttachmentConnection";
	MediaAttachmentEdge: "MediaAttachmentEdge";
	Message: "Message";
	MessageConnection: "MessageConnection";
	MessageEdge: "MessageEdge";
	MessageGroup: "MessageGroup";
	MessageGroupConnection: "MessageGroupConnection";
	MessageGroupEdge: "MessageGroupEdge";
	MessageGroupArchivePoint: "MessageGroupArchivePoint";
	MessageGroupArchivePointConnection: "MessageGroupArchivePointConnection";
	MessageGroupArchivePointEdge: "MessageGroupArchivePointEdge";
	MessageTopic: "MessageTopic";
	MessageTopicConnection: "MessageTopicConnection";
	MessageTopicEdge: "MessageTopicEdge";
	Newsletter: "Newsletter";
	NewsletterConnection: "NewsletterConnection";
	NewsletterEdge: "NewsletterEdge";
	Permission: "Permission";
	PermissionConnection: "PermissionConnection";
	PermissionEdge: "PermissionEdge";
	PermissionGroup: "PermissionGroup";
	PermissionGroupConnection: "PermissionGroupConnection";
	PermissionGroupEdge: "PermissionGroupEdge";
	Post: "Post";
	PostConnection: "PostConnection";
	PostEdge: "PostEdge";
	SharingPolicy: "SharingPolicy";
	SharingPolicyConnection: "SharingPolicyConnection";
	SharingPolicyEdge: "SharingPolicyEdge";
	SocialComment: "SocialComment";
	SocialCommentConnection: "SocialCommentConnection";
	SocialCommentEdge: "SocialCommentEdge";
	SocialReaction: "SocialReaction";
	SocialReactionConnection: "SocialReactionConnection";
	SocialReactionEdge: "SocialReactionEdge";
	User: "User";
	UserConnection: "UserConnection";
	UserEdge: "UserEdge";
	UserGroup: "UserGroup";
	UserGroupConnection: "UserGroupConnection";
	UserGroupEdge: "UserGroupEdge";
	UserViewRecord: "UserViewRecord";
	UserViewRecordConnection: "UserViewRecordConnection";
	UserViewRecordEdge: "UserViewRecordEdge";
};

/**
 * Stores the type name for each model for use in local GraphQL data (as the `__typename` field).
 */
export const graphTypeNames: GraphTypeNames = {
	Announcement: "Announcement",
	AnnouncementConnection: "AnnouncementConnection",
	AnnouncementEdge: "AnnouncementEdge",
	CalendarEvent: "CalendarEvent",
	CalendarEventConnection: "CalendarEventConnection",
	CalendarEventEdge: "CalendarEventEdge",
	CalendarEventResponse: "CalendarEventResponse",
	CalendarEventResponseConnection: "CalendarEventResponseConnection",
	CalendarEventResponseEdge: "CalendarEventResponseEdge",
	MediaAttachment: "MediaAttachment",
	MediaAttachmentConnection: "MediaAttachmentConnection",
	MediaAttachmentEdge: "MediaAttachmentEdge",
	Message: "Message",
	MessageConnection: "MessageConnection",
	MessageEdge: "MessageEdge",
	MessageGroup: "MessageGroup",
	MessageGroupConnection: "MessageGroupConnection",
	MessageGroupEdge: "MessageGroupEdge",
	MessageGroupArchivePoint: "MessageGroupArchivePoint",
	MessageGroupArchivePointConnection: "MessageGroupArchivePointConnection",
	MessageGroupArchivePointEdge: "MessageGroupArchivePointEdge",
	MessageTopic: "MessageTopic",
	MessageTopicConnection: "MessageTopicConnection",
	MessageTopicEdge: "MessageTopicEdge",
	Newsletter: "Newsletter",
	NewsletterConnection: "NewsletterConnection",
	NewsletterEdge: "NewsletterEdge",
	Permission: "Permission",
	PermissionConnection: "PermissionConnection",
	PermissionEdge: "PermissionEdge",
	PermissionGroup: "PermissionGroup",
	PermissionGroupConnection: "PermissionGroupConnection",
	PermissionGroupEdge: "PermissionGroupEdge",
	Post: "Post",
	PostConnection: "PostConnection",
	PostEdge: "PostEdge",
	SharingPolicy: "SharingPolicy",
	SharingPolicyConnection: "SharingPolicyConnection",
	SharingPolicyEdge: "SharingPolicyEdge",
	SocialComment: "SocialComment",
	SocialCommentConnection: "SocialCommentConnection",
	SocialCommentEdge: "SocialCommentEdge",
	SocialReaction: "SocialReaction",
	SocialReactionConnection: "SocialReactionConnection",
	SocialReactionEdge: "SocialReactionEdge",
	User: "User",
	UserConnection: "UserConnection",
	UserEdge: "UserEdge",
	UserGroup: "UserGroup",
	UserGroupConnection: "UserGroupConnection",
	UserGroupEdge: "UserGroupEdge",
	UserViewRecord: "UserViewRecord",
	UserViewRecordConnection: "UserViewRecordConnection",
	UserViewRecordEdge: "UserViewRecordEdge",
};
